
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter1 as ObiFilter1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-1.js';
 
 
 

 
 export const ObiFilter1 = createComponent({
   react: React,
   tagName: 'obi-filter-1',
   elementClass: ObiFilter1Element,
   events: {
     
   }
  });
 
 